/**
 * 预约设置
 */
import { APPOINTMENTSETTING } from '../types';

export default {
    name: `${APPOINTMENTSETTING}`,
    path: '/appointmentSetting',
    component: () => import(/* webpackChunkName: 'appointmentSetting' */ '@/views/appointmentSetting/'),
    redirect: { name: `${APPOINTMENTSETTING}Index` },
    meta: {
        title: '预约设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${APPOINTMENTSETTING}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'appointmentSetting' */ '@/views/appointmentSetting/home/Home.vue'),
        },
        {
            name: `${APPOINTMENTSETTING}Schedule`,
            path: 'schedule',
            component: () => import(/* webpackChunkName: 'appointmentSetting' */ '@/views/appointmentSetting/schedule/Schedule.vue'),
        },
    ],
};
